
import React, { useMemo } from "react";
import { Segment, Grid } from "semantic-ui-react";
import _uniqueId from "lodash/uniqueId"
import { TimeList } from "./TimeList";
import { TFunction } from "i18next";
import { useTranslation } from "react-i18next";
import "./_HourMinuteSelect.less"

const hours = Array(24).fill(null).map((_, i) => String(i).padStart(2, "0"));
const minutes = Array(60).fill(null).map((_, i) => String(i).padStart(2, "0"));

const timeToOptions = (num: string) => ({ text: num, value: num, key: _uniqueId() })

const hourOptions = hours.map(timeToOptions)
const minutesOptions = minutes.map(timeToOptions)

const getTextProps = (t: TFunction) => ({
    hour: t("Tunti"),
    minute: t("Minuutti"),

});

interface IHourMinuteSelect {
    value?: string;
    minDate?: Date
    maxDate?: Date;
    onChange?: (date: string | undefined) => void;
}


export const HourMinuteSelect: React.FC<IHourMinuteSelect> = ({

    value = "00:00",
    minDate,
    maxDate,
    onChange = () => null,

}) => {
    const texts = getTextProps(useTranslation().t);

    const [minHour, minMinute] = minDate ? [minDate.getHours(), minDate.getMinutes()].map(String) : []
    const [maxHour, maxMinute] = maxDate ? [maxDate.getHours(), maxDate.getMinutes()].map(String) : []

    let [hour, minute] = value?.split(":")
    if (hour) hour = hour.padStart(2, "0");
    if (minute) minute = minute.padStart(2, "0");

    const onHourClick = (value: string = "") => {
        onChange([value, (minute || "00")].join(":"))
    };
    const onMinuteClick = (value: string = "") => {
        onChange([(hour || "01"), value].join(":"))
    };
    const isMinHour = minHour && hour && parseFloat(minHour) === parseFloat(hour);
    const isMaxHour = maxHour && hour && parseFloat(maxHour) === parseFloat(hour);

    const optionsHour = useMemo(() => (
        hourOptions.filter((hour) => {

            if (minHour && parseFloat(hour.value) < parseFloat(minHour)) return false
            if (maxHour && parseFloat(hour.value) > parseFloat(maxHour)) return false
            return true
        }
        )), [minHour, maxHour])

    const optionsMinute = useMemo(() => (
        minutesOptions.filter((minute) => {
            if (isMinHour && minMinute && parseFloat(minute.value) < parseFloat(minMinute)) return false
            if (isMaxHour && maxMinute && parseFloat(minute.value) > parseFloat(maxMinute)) return false
            return true
        }
        )), [minMinute, maxMinute, isMinHour, isMaxHour]);

    return (
        <Segment basic className="HourMinuteSelect">
            <Grid columns="equal">
                <Grid.Column style={{ paddingRight: 0, paddingLeft: 0, paddingTop: 0 }}>

                    <TimeList label={texts.hour} list={optionsHour} onSelect={onHourClick} selected={hour} />
                </Grid.Column>

                <Grid.Column style={{ paddingRight: 0, paddingLeft: 0, paddingTop: 0 }}>

                    <TimeList label={texts.minute} list={optionsMinute} onSelect={onMinuteClick} selected={minute} />
                </Grid.Column>
            </Grid>
        </Segment>
    )
};
